import { MILLET_OPEN_DASHBOARD_SIDEBAR_EVENT } from './dashboardSidebarLayout';

/** Opens the dashboard drawer on mobile/tablet layouts. */
export function openDashboardSidebar() {
  window.dispatchEvent(new Event(MILLET_OPEN_DASHBOARD_SIDEBAR_EVENT));
}

export default openDashboardSidebar;
